import { PASSWORD_CHANGE_BY } from './constant';

// app/sagas/misc.js
export function passwordChangeBy(changeBy) {
  return { type: PASSWORD_CHANGE_BY, payload: { changeBy } };
}
